<script>
import { api } from "@/state/services";
import { required } from "vuelidate/lib/validators";

export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,

      form: {
        type: "natural",
        name: "",
        personNumber: "",
        companyPartnerName: "",
        companyPartnerCpf: "",
        email: "",
        cellphone: "",
        observations: "",
      },
    };
  },
  validations: {
    form: {
      type: { required },
      name: { required },
      personNumber: { required },
      email: { required },
      cellphone: { required },
    },
  },
  computed: {
    show: {
      get() {
        return this.modal;
      },
      set(value) {
        this.$emit("update:modal", value);
      },
    },
  },
  watch: {
    'form.type'() {
      this.form.personNumber = ''
      this.form.companyPartnerName = ''
      this.form.companyPartnerCpf = ''
    },
  },
  methods: {
    addClient() {
      this.loading = true
      this.$v.form.$touch();

      if (!this.$v.form.$invalid) {
        api
          .post('jusbrasil/clients', {
            type: this.form.type,
            name: this.form.name,
            personNumber: this.form.personNumber,
            companyPartnerName: this.form.companyPartnerName,
            companyPartnerCpf: this.form.companyPartnerCpf,
            email: this.form.email,
            cellphone: this.form.cellphone,
            observations: this.form.observations,
          })
          .then(response => {
            if (response.data.status == 'success') {
              this.resetForm()

              this.show = false
              this.loading = false

              this.$toast.success('O cliente adicionado com sucesso!')

              this.$emit('added')
            } else {
              this.loading = false
              this.$toast.error(response.data.message)
            }
          })
          .catch(error => {
            if (error) {
              this.loading = false
            }
          })
      } else {
        this.loading = false
      }
    },
    resetForm() {
      this.form.type = 'natural'
      this.form.name = ''
      this.form.personNumber = ''
      this.form.companyPartnerName = ''
      this.form.companyPartnerCpf = ''
      this.form.email = ''
      this.form.cellphone = ''
      this.form.observations = ''
      this.$v.form.$reset()
    },
  },
};
</script>

<template>
  <b-modal v-model="show" title="Novo Cliente" modal-class="modal-right" hide-footer @show="loading = false">
    <b-form @submit.prevent="addClient">
      <b-form-group id="type-group" :label="t('Tipo de Pessoa')" label-for="type">
        <select v-model="form.type" class="custom-select mb-1" :class="{ 'is-invalid': $v.form.type.$error }">
          <option value="natural">Pessoa Física</option>
          <option value="legal">Pessoa Jurídica</option>
        </select>
        <div v-if="!$v.form.type.required" class="invalid-feedback">
          O tipo de pessoa é obrigatório.
        </div>
      </b-form-group>
      <template v-if="form.type == 'natural'">
        <b-form-group id="name-natural-group" key="name-natural-group" label="Nome" label-for="name-natural">
          <b-form-input id="name-natural" v-model="form.name" type="text" :class="{ 'is-invalid': $v.form.name.$error }"></b-form-input>
          <div v-if="!$v.form.name.required" class="invalid-feedback">
            O nome é obrigatório.
          </div>
        </b-form-group>

        <b-form-group id="cpf-group" key="cpf-group" label="CPF" label-for="cpf">
          <b-form-input id="cpf" v-model="form.personNumber" type="text" v-mask="'###.###.###-##'" :class="{ 'is-invalid': $v.form.personNumber.$error }" inputmode="numeric"></b-form-input>
          <div v-if="!$v.form.personNumber.required" class="invalid-feedback">
            O CPF é obrigatório.
          </div>
        </b-form-group>
      </template>
      <template v-else>
        <b-form-group id="name-legal-group" key="name-legal-group" label="Razão Social" label-for="name-legal">
          <b-form-input id="name-legal" v-model="form.name" type="text" :class="{ 'is-invalid': $v.form.name.$error }"></b-form-input>
          <div v-if="!$v.form.name.required" class="invalid-feedback">
            O nome é obrigatório.
          </div>
        </b-form-group>

        <b-form-group id="cnpj-group" key="cnpj-group" label="CNPJ" label-for="cnpj">
          <b-form-input id="cnpj" v-model="form.personNumber" type="text" v-mask="'##.###.###/####-##'" :class="{ 'is-invalid': $v.form.personNumber.$error }" inputmode="numeric"></b-form-input>
          <div v-if="!$v.form.personNumber.required" class="invalid-feedback">
            O CNPJ é obrigatório.
          </div>
        </b-form-group>

        <b-form-group id="partner-name-group" key="partner-name-group" label="Nome do Sócio" label-for="partner-name">
          <b-form-input id="partner-name" v-model="form.companyPartnerName" type="text"></b-form-input>
        </b-form-group>

        <b-form-group id="partner-cpf-group" key="partner-cpf-group" label="CPF do Sócio" label-for="partner-cpf">
          <b-form-input id="partner-cpf" v-model="form.companyPartnerCpf" type="text" v-mask="'###.###.###-##'" inputmode="numeric"></b-form-input>
        </b-form-group>

      </template>

      <b-form-group id="email-group" label="Email" label-for="email">
        <b-form-input id="email" v-model="form.email" type="email" :class="{ 'is-invalid': $v.form.email.$error }" inputmode="email"></b-form-input>
        <div v-if="!$v.form.email.required" class="invalid-feedback">
          O email é obrigatório.
        </div>
      </b-form-group>

      <b-form-group id="cellphone-group" label="Celular/Whatsapp" label-for="cellphone">
        <b-form-input id="cellphone" v-model="form.cellphone" type="text" v-mask="'(##) #####-####'" :class="{ 'is-invalid': $v.form.cellphone.$error }" inputmode="numeric"></b-form-input>
        <div v-if="!$v.form.cellphone.required" class="invalid-feedback">
          O celular é obrigatório.
        </div>
      </b-form-group>

      <b-form-group id="observations-group" label="Observações" label-for="observations">
        <b-form-textarea id="observations" v-model="form.observations" maxlength="100"></b-form-textarea>
        <div class="font-size-12 p-2 px-3 mt-1 bg-soft-info rounded d-flex flex-gap-10 align-items-center" style="line-height: 15px;">
          <span>{{ form.observations.length }}/100 caracteres</span>
        </div>
      </b-form-group>

      <b-button class="mt-5 btn-lg btn-block" :disabled="loading" type="submit" variant="default">
        Adicionar
        <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
      </b-button>
    </b-form>
  </b-modal>
</template>

<style scoped>
button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>
